import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import { HttpModule, Http } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { CoreModule } from "./core/core.module";
import { PipesModule } from './pipes/pipes.module';
import { MyApp } from './app.component';
import { BTInputPage } from '../pages/bt/bt-input/bt-input';
import { BTModalPage } from '../pages/bt/bt-modal/bt-modal';
import { MeasureInputPage } from '../pages/measure-input/measure-input';
import { ObservationModalPage } from '../pages/measure-input/observation-modal/observation-modal';
import { OtherPkModalPage } from '../pages/measure-input/other-pk-modal/other-pk-modal';
import { SummaryPage } from '../pages/summary/summary';
import { TabsPage } from '../pages/tabs/tabs';
import { UpdatePage } from '../pages/update/update';
import { ActionButtons } from '../pages/measure-input/action-buttons/action-buttons';
import { Information } from '../pages/measure-input/information-box/information';
import { Location } from '../pages/measure-input/location/location';
import { MeasureSchema } from '../pages/measure-input/measure-schema/measure-schema';

import { ConfigLoader } from './config-loader';
import { Api } from './core/api';
import { ConfigService } from './config.service';
import { SummaryService } from '../pages/summary/summary.service';
import { ThemeProvider } from '../providers/theme/theme';

export function httpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

const pages = [
  MyApp,
  BTInputPage,
  BTModalPage,
  MeasureInputPage,
  ObservationModalPage,
  OtherPkModalPage,
  SummaryPage,
  TabsPage,
  UpdatePage,
  ActionButtons,
  Information,
  Location,
  MeasureSchema
];

@NgModule({
  declarations: pages,
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    HttpModule,
    NguiAutoCompleteModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (httpLoaderFactory),
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot(MyApp, {
      tabsPlacement: 'top' ,
      tabsLayout: 'icon-hide',
      tabsHighlight: true
    }, {
      links: [
        { component: BTInputPage, name: 'Saisie de BT', segment: 'bt' },
        { component: MeasureInputPage, name: 'Saisie de mesure', segment: 'measure' },
        { component: SummaryPage, name: 'Récapitulatif', segment: 'summary' },
        { component: TabsPage, name: 'Tabs', segment: 'tabs' },
        { component: UpdatePage, name: 'Mise à jour', segment: 'update' }
      ]
    }),
    CoreModule,
    PipesModule,
  ],
  providers: [
    ThemeProvider,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigLoader,
      deps: [ConfigService],
      multi: true
    },
    Api,
    SummaryService,
    // Keep this to enable Ionic's runtime error handling during development
    //TODO remove when building in production mode
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    ThemeProvider
  ],
  entryComponents: pages,
  bootstrap: [IonicApp]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts